var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{attrs:{"stacked":"md","fixed":"","responsive":"","res":"","items":_vm.itemsByOrder,"fields":_vm.fields},scopedSlots:_vm._u([{key:"cell(item_image)",fn:function(ref){
var item = ref.item;
return [_c('article',{staticClass:"rma-product"},[_c('img-product',{attrs:{"imgPath":item.image_url,"alt":item.item_name,"styleImage":{ maxWidth: '60px' }}})],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }